import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent } from "@shared/ui/card";
import { Button } from "@shared/ui/button";
import { Badge } from "@shared/ui/badge";
import {
  Clipboard,
  Plus,
  Settings,
  Ruler,
} from "lucide-react";
import { TabProps } from "@features/mx/device-management/types";
import { useMeterWorkorderInfo } from "@features/mx/device-management/hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { PageHeader } from "@shared/components/PageHeader";

const WorkOrdersTab: React.FC<TabProps> = ({tab, meterId})=> {
  const navigate = useNavigate();
  const remoteUtilityId = useRemoteUtilityId();
  const { data: workOrders} = useMeterWorkorderInfo({meterId, remoteUtilityId});
  console.log('debug wo', workOrders)
  
  const handleNavigate = (status: string, id: number) => {
    const normalizedStatus = status?.toLowerCase();
    
    switch (normalizedStatus) {
      case "created":
        navigate(`/service-orders/dispatcher/pending-meter-service-order/${id}`);
        break;
      case "assigned":
        navigate(`/service-orders/dispatcher/assigned-meter-service-order/${id}`);
        break;
      case "pending":
        navigate(`/service-orders/dispatcher/pending-meter-service-order/${id}`);
        break;
      case "completed":
        navigate(`/service-orders/dispatcher/completed-meter-service-order/${id}`);
        break;
      case "approved":
        navigate(`/service-orders/dispatcher/history-service-order/${id}`);
        break;
      default:
        navigate(`/service-orders/dispatcher/pending-meter-service-order/${id}`);
    }
  };
  
  return (
    <Card className="shadow-sm">
      <CardHeader className="">
        <div className="flex justify-between items-center">
        
<PageHeader
  title="Work Orders"
  icon={Clipboard}
/>
        </div>
      </CardHeader>
      <CardContent className="py-3">
        {workOrders?.length > 0 ? (
          <div className="grid grid-cols-1 gap-3">
            {workOrders?.map((wo) => (
              <Card key={wo.id} className="border shadow-sm">
                <CardContent className="p-3">
                  <div className="flex justify-between items-start">
                    <div>
                      <div className="font-medium flex items-center gap-1">
                        <Ruler className="h-3 w-3 text-purple-500" />
                        {wo.sopOperationTypeDisplay}
                      </div>
                      <div className="text-xs text-muted-foreground mt-1">
                        {wo.createdDate} • {wo.createdUserRemoteName}
                      </div>
                    </div>
                    <Badge
                      variant={
                        wo.statusDisplay === "COMPLETED" ? "outline" : "default"
                      }
                      className={
                        wo.status === "COMPLETED"
                          ? "text-green-600"
                          : "bg-amber-100 text-amber-800 hover:bg-amber-100"
                      }
                    >
                      {wo.statusDisplay}
                    </Badge>
                  </div>
                  <div className="mt-2 text-xs">{wo.remark ?? "NA"}</div>
                  <div className="mt-3">
                    <Button
                      variant="outline"
                      size="sm"
                      className="w-full text-xs"
                      onClick={() => handleNavigate(wo.status, wo.id)}
                    >
                      View Details
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-4">
            <div className="mx-auto w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center mb-2">
              <Clipboard className="h-5 w-5 text-gray-600" />
            </div>
            <h3 className="text-sm font-medium mb-1">No Work Orders</h3>
            <p className="text-xs text-muted-foreground mb-3">
              This meter has no associated work orders.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default WorkOrdersTab;